var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tickets-dashboard-graph-container",staticStyle:{"height":"400px","margin-top":"-50px"}},[_c('div',{ref:"ticketsLocationGraph",staticStyle:{"width":"100%","height":"100%","overflow":"hidden"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }